import cn from "classnames";
import { useTranslation } from "react-i18next";

import { OrderModalBlockProps } from "../../OrderModal.types";

import styles from "../../OrderModal.module.scss";

export const OrderModalBlock = ({
  label,
  children,
  className
}: OrderModalBlockProps) => {
  const { t } = useTranslation();

  return (
    <div className={cn(styles.orderModal__block, className)}>
      {label && (
        <div className={styles.orderModal__block__label}>{t(label)}</div>
      )}
      {children}
    </div>
  );
};
